import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from './../../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  errorMessage: string = '';

  constructor(private formBuilder: FormBuilder, private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      // email: ['', [Validators.required, Validators.email]],
      username: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._]+$/)]],
      password: ['', Validators.required],
      rememberMe: []
    });
  }

  onSignIn(username: string, password: string): void {
    const success = false;

    this.authService.signIn(username.trim(), password.trim()).subscribe({
      next: response => {
        if (response && response.accessToken) {
          // Store the token in local storage
          localStorage.setItem('current_user', JSON.stringify(response));
          localStorage.setItem('access_token', response.accessToken);
          // Navigate to the dashboard
          this.router.navigate(['/dashboard']);
        } else
          this.errorMessage = 'Invalid username or password';
      }, error: error => {
        console.log(error);
        this.errorMessage = 'Invalid username or password';
      },
      complete: () => console.info('complete')
    });
    
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.onSignIn(this.loginForm.get('username')?.value, this.loginForm.get('password')?.value);

    } else {
      this.errorMessage = 'Invalid username or password.';
    }
  }
}
